import { useContext } from 'react'

import { UIDispatchContext } from '../../constants'

const useUIDispatch = () => {
    const context = useContext(UIDispatchContext)
    if (context === undefined) {
        throw new Error('UIDispatchContext must be within provider')
    }
    return context
}

export default useUIDispatch
